import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';
import { ERROR_MESSAGE } from '../lib/constants';


export const getAllPermissionGroups = token => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'FETCH_ALL_PERMISSION_GROUPS',
  });
  try {
    const permissionGroups = await api.permissionGroups.getAllPermissionGroups();
    dispatch({
      type: 'FETCH_ALL_PERMISSION_GROUPS_SUCESS',
      permissionGroups: permissionGroups,
    });
    return permissionGroups
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'FETCH_ALL_PERMISSION_GROUPS_FAILURE',
    });
    dispatch({
      type: 'FETCH_ALL_PERMISSION_GROUPS_FAILURE',
      error,
    });
  }
};

export const updatePermissionGroups = (token, permissionGroups) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'UPDATE_ALL_PERMISSION_GROUPS',
  });
  try {
    const updatedPermissionGroups = await api.permissionGroups.updatePermissionGroups(permissionGroups);
    if(updatedPermissionGroups){
      dispatch({
        type: 'FETCH_ALL_PERMISSION_GROUPS_SUCESS',
        permissionGroups: permissionGroups,
      });
      toast.success('Permissions groups updated successfully!');
    }
  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'UPDATE_ALL_PERMISSION_GROUPS_FAILURE',
    });
    dispatch({
      type: 'UPDATE_ALL_PERMISSION_GROUPS_FAILURE',
      error,
    });
  }
};

export const getUserPermissionGroup = token => async dispatch => {
  console.log("FETCH_PERMISSION_GROUPS_SUCCESS");

  const api = new Api(token);
  dispatch({
    type: 'FETCH_PERMISSION_GROUPS',
  });
  try {
    const data = await api.permissionGroups.getUserPermissionGroup();
    dispatch({
      type: 'FETCH_PERMISSION_GROUPS_SUCCESS',
      permissionGroup: data.permissions,
    });
    console.log("FETCH_PERMISSION_GROUPS_SUCCESS");

  } catch (error) {
    // Error Message from API
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'FETCH_PERMISSION_GROUPS_FAILURE',
    });
    dispatch({
      type: 'FETCH_PERMISSION_GROUPS_FAILURE',
      error,
    });
  }
};